import { FC } from 'react';

interface DescriptionListItemProps {
  description: string;
  index: number
}

export const DescriptionListItem: FC<DescriptionListItemProps> = ({ index, description }) => {
  return (
    <li key={index} className="text-lg">{description}</li>
  )
};